// extracted by mini-css-extract-plugin
module.exports = {"Landing":"Landing_Landing__O8Zfl","Landing__Details":"Landing_Landing__Details__1kOI1"};